var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-event',{attrs:{"range":_vm.range},model:{value:(_vm.event),callback:function ($$v) {_vm.event=$$v},expression:"event"}}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('filter-range',{model:{value:(_vm.money),callback:function ($$v) {_vm.money=$$v},expression:"money"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b766c46","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-event-delivery-of-change.vue
// module id = null
// module chunks = 